import '@/util/permission';
import Vue from 'vue';
import * as echarts from 'echarts/core';
import * as utils from '@/util/format';
import VueMoment from 'vue-moment';
import { ValidationProvider } from 'vee-validate';
import '@/util/vee-validate';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'tabulator-tables/dist/css/tabulator_midnight.min.css';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locale';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Router from 'vue-router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VChart from 'vue-echarts';
import VueTabulator from 'vue-tabulator';
import VueApexCharts from 'vue-apexcharts';

import { createPinia, PiniaVuePlugin } from 'pinia';
import {
	round_off as g_round_off,
	round_percent as g_round_percent,
	number_2_text as g_number_2_text,
} from '@/util/format';

import {
	LocalStorage,
	SessionStorage,
} from '@/storage';
import * as g_aq from 'arquero';
import * as ApexHandler from '@/assets/chart_handler/ApexHandler';
import * as EChartsHandler from '@/assets/chart_handler/EChartsHandler';
import * as TabuHandler from '@/assets/chart_handler/TabuHandler';

global.g_round_off = g_round_off;
global.g_round_percent = g_round_percent;
global.g_number_2_text = g_number_2_text;

global.g_aq = g_aq;
global.ApexHandler = ApexHandler;
global.EChartsHandler = EChartsHandler;
global.TabuHandler = TabuHandler;

global.LocalStorage = LocalStorage.constructor();
global.SessionStorage = SessionStorage.constructor();

import 'swiper/dist/css/swiper.css';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { BarChart, FunnelChart, HeatmapChart, LineChart, PieChart, SankeyChart, RadarChart } from 'echarts/charts';
import {
	BrushComponent,
	DatasetComponent,
	DataZoomComponent,
	DataZoomInsideComponent,
	DataZoomSliderComponent,
	GridComponent,
	GridSimpleComponent,
	GraphicComponent,
	MarkLineComponent,
	MarkPointComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	TransformComponent,
	LegendComponent,
	LegendScrollComponent,
	LegendPlainComponent,
	VisualMapComponent
} from 'echarts/components';
echarts.use([
	CanvasRenderer, SVGRenderer,
	BarChart, FunnelChart, HeatmapChart, LineChart, PieChart, SankeyChart, RadarChart,
	BrushComponent,
	DatasetComponent,
	DataZoomComponent,
	DataZoomInsideComponent,
	DataZoomSliderComponent,
	GridComponent,
	GridSimpleComponent,
	GraphicComponent,
	MarkLineComponent,
	MarkPointComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	TransformComponent,
	LegendComponent,
	LegendScrollComponent,
	LegendPlainComponent,
	VisualMapComponent
]);

Vue.config.productionTip = false;
Vue.use(VueMoment);
Vue.use(VueAwesomeSwiper);
Vue.use(VueTabulator);
Vue.use(VueApexCharts);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.component('v-chart', VChart);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('apexchart', VueApexCharts);
// Vue.component(ValidationProvider);

Vue.filter('commaFormatter', value => utils.commaFormatter(value));

new Vue({
	vuetify,
	router,
	store,
	pinia,
	i18n,
	render: h => h(App)
}).$mount('#app');

// 避免Router重複點擊錯誤
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error);
};
